<script>

    import { onMount } from 'svelte'

    import IntegrationsService from '../$services/integrations.service'
    import NumeralMethods from '../$methods/numeral.methods'
    import StatsCard from '../$components/stats.card.svelte'

    export let partner = ''

    let value = '—'

    onMount(load)

    async function load() {
        if (!partner) return

        const res = await IntegrationsService.getIntegration(partner)
        const balance = res?.data?.balance

        value = balance == null ? 'Error' : NumeralMethods.cash(balance)
    }

</script>

<StatsCard
    icon="fas fa-wallet"
    title="Saldo { partner }"
    { value }
    change={null}
    compare=""
/>
